import React, {useCallback, useState} from 'react'
import {Checkbox} from "@material-ui/core";

const UCCheckbox = ({data, name, rawData, single=false}) => {
  const [value, setValue] = useState(data[name] || false)
  const onClick = useCallback(() => {
    setValue(value => {
      if (value) {
        // data[name] = false
        delete data[name]
        return false
      }
      if (single && data && Object.keys(data).length) return false
      data[name] = rawData
      return rawData
    })
  }, [rawData, single])

  return (
    <div onClick={onClick} style={{width: 40, display: "inline-block"}}>
      <Checkbox
        checked={!!value}
      />
    </div>
  )
}

export default UCCheckbox